import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

export const SERVICES = [
  {
    name: "Furniture Assembly",
    price: "from £40",
    img: "https://images.pexels.com/photos/7491417/pexels-photo-7491417.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=500&w=700",
  },
  {
    name: "TV Mounting",
    price: "from £50",
    img: "https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?auto=format&fit=crop&w=700&q=80",
  },
  {
    name: "Shelves & Mirrors",
    price: "from £35",
    img: "https://images.unsplash.com/photo-1618220179428-22790b461013?auto=format&fit=crop&w=700&q=80",
  },
  {
    name: "Beds & Wardrobes",
    price: "from £55",
    img: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=700&q=80",
  },
  {
    name: "Moving Help",
    price: "from £60",
    img: "https://images.unsplash.com/photo-1714647211902-bb711d643a17?auto=format&fit=crop&w=700&q=80",
  },
  {
    name: "Gardening",
    price: "from £35",
    img: "https://images.unsplash.com/photo-1601001815894-4bb6c81416d7?auto=format&fit=crop&w=700&q=80",
  },
  {
    name: "Cleaning",
    price: "from £30",
    img: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=700&q=80",
  },
  {
    name: "General Handyman",
    price: "from £45",
    img: "https://images.unsplash.com/photo-1676630656246-3047520adfdf?auto=format&fit=crop&w=700&q=80",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <Eyebrow>Services</Eyebrow>
            <h2 className="mt-4 font-display font-extrabold tracking-tight text-navy text-3xl sm:text-4xl lg:text-5xl max-w-xl">
              Whatever needs doing, find someone to do it.
            </h2>
          </div>
          <a
            href="#app"
            data-testid="services-explore-btn"
            className="group inline-flex items-center gap-2 self-start md:self-auto text-sm font-semibold text-navy border border-slate-300 hover:border-teal hover:text-teal px-6 py-3.5 rounded-full transition-colors duration-200"
          >
            Explore all services
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" />
          </a>
        </Reveal>

        <div className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SERVICES.map((s, i) => (
            <Reveal key={s.name} delay={(i % 4) * 0.08}>
              <a
                href="#app"
                data-testid={`service-card-${s.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="group block bg-paper rounded-2xl overflow-hidden border border-slate-200/60 hover:border-teal/40 hover:shadow-xl hover:shadow-navy/5 transition-[box-shadow,border-color] duration-300"
              >
                <div className="relative aspect-[4/3] overflow-hidden bg-slate-200">
                  <img
                    src={s.img}
                    alt={s.name}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                  />
                  <span className="absolute top-3 right-3 w-9 h-9 rounded-full bg-white/90 backdrop-blur grid place-items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <ArrowUpRight className="w-4 h-4 text-navy" />
                  </span>
                </div>
                <div className="p-5 flex items-center justify-between">
                  <h3 className="font-display font-bold text-navy text-base">{s.name}</h3>
                  <span className="text-xs font-mono font-medium text-teal">{s.price}</span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
